<nav class="navbar navbar-expand-sm bg-dark navbar-dark">
    <div class="container">
       <a class="navbar-brand" href="#"><img src="assets/images/1.svg" 
          style="height:30px"></a>
       <ul class="nav navbar-nav navbar-right">
          <li class="nav-item">
             <a class="nav-link" id="a" href="#">Guides</a>
          </li>
          <li class="nav-item">
             <a class="nav-link" id="a" href="#">Blog</a>
          </li>
          <li class="nav-item">
             <a class="nav-link" id="a" href="#">About Us</a>
          </li>
          <li class="nav-item">
             <a class="nav-link"  id="a" href="#">***</a>
          </li>
          <li class="nav-item">
             <a class="nav-link" href="#"><button type="button" id="btn" 
                class="btn btn-default">Login</button></a>
          </li>
       </ul>
    </div>
 </nav>

  








 <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" style="margin-top:10px;border: 1px solid gray;background-color: gray;background-color: #e4a6a8;">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <video width="95%" height="250" controls   style="margin-left: 50px;margin-right: 50px;">
            <source  src="assets/images/vedio123.mp4" type="video/mp4">
        </video>
      </div>
    
      <div class="carousel-item">
<video width="95%" height="250" controls   style="margin-left: 50px;margin-right: 50px;">           
     <source  src="assets/images/vedio123.mp4" type="video/mp4">
        </video>    
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev"  >
      <span class="carousel-control-prev-icon" aria-hidden="true" style="color:red"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>


  <div class="row" style="margin-top: 20px;">

    
    <div class="col-lg-4 col-md-12 mb-4"  >
        <div class="background">
           <video width="400" height="300" controls   style="margin: auto;display: block;margin-bottom: 40px;"   >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>


    <div class="col-lg-4 col-md-12 mb-4"  >
        <div class="background">
           <video width="400" height="300" controls   style="margin: auto;display: block;margin-bottom: 40px;"  >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>


    <div class="col-lg-4 col-md-12 mb-4"  >
        <div class="background">
           <video width="400" height="300" controls   style="margin: auto;display: block;margin-bottom: 40px;"  >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>

  </div>

 

  <div class="row" style="margin-top: 20px;">

    
    <div class="col-lg-3 col-md-12 mb-3"  >
        <div class="background">
           <video width="280" height="200" controls   style="margin-left: 10px;"  >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>


    <div class="col-lg-3 col-md-6 mb-3"  >
        <div class="background">
           <video width="280" height="200" controls   style="margin-left: 10px;"  >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>

    <div class="col-lg-3 col-md-6 mb-3"  >
        <div class="background">
           <video width="280" height="200" controls   style="margin-left: 10px;"  >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>
    <div class="col-lg-3 col-md-6 mb-3"  >
        <div class="background">
           <video width="280" height="200" controls   style="margin-left: 10px;"  >
                <source  src="assets/images/vedio123.mp4" type="video/mp4">
            </video>
    </div>
    </div>

</div>









<div class = "row">
    <div class = "col-sm-6 col-md-3">
        <div class="background">
       <div class = "thumbnail">
        <video width="280" height="200" controls   style="margin-left: 10px;"  >
            <source  src="assets/images/vedio123.mp4" type="video/mp4">
        </video>
       </div>
       
       <div class = "caption">
        <h3 style="text-align: center;">Thumbnail label</h3>
        <p style="text-align: center;">Some sample text</p>
          
          <button class="button">Action</button>
       </div>
       </div>
    </div>

    <div class = "col-sm-6 col-md-3">
        <div class="background">
        <div class = "thumbnail">
         <video width="280" height="200" controls   style="margin-left: 10px;"  >
             <source  src="assets/images/vedio123.mp4" type="video/mp4">
         </video>
        </div>
        
        <div class = "caption">
            <h3 style="text-align: center;">Thumbnail label</h3>
            <p style="text-align: center;">Some sample text</p>
           <button class="button">Action</button>
        </div>
        </div>
     </div>

     <div class = "col-sm-6 col-md-3">
        <div class="background">
        <div class = "thumbnail">
         <video width="280" height="200" controls   style="margin-left: 10px;"  >
             <source  src="assets/images/vedio123.mp4" type="video/mp4">
         </video>
        </div>
        
        <div class = "caption">
            <h3 style="text-align: center;">Thumbnail label</h3>
            <p style="text-align: center;">Some sample text</p>
           <button class="button">Action</button>
        </div>
        </div>
     </div>

     <div class = "col-sm-6 col-md-3">
        <div class="background">
        <div class = "thumbnail">
         <video width="280" height="200" controls   style="margin-left: 10px;"  >
             <source  src="assets/images/vedio123.mp4" type="video/mp4">
         </video>
        </div>
        
        <div class = "caption">
           <h3 style="text-align: center;">Thumbnail label</h3>
           <p style="text-align: center;">Some sample text</p>
       <button class="button">Action</button>
        </div>
     </div>
     </div>
    </div>
